import React, { useState } from "react";


import "../styles/PrivacyNotice.css";
import Footer from '../component/footer';
import { Link, useParams, useLocation, Routes, Route } from "react-router-dom";

const PrivacyNotice = () => {
    return (
        <div className="privacy-page">

            <div className="privacy_content">

                <h3> XOX’s Privacy Notice </h3>
                <h1>
                    This Privacy Notice is communicated for and on behalf of XOX BHD and its group
                    of companies (hereinafter collectively referred to as “XOX”, “we” or “us”). We
                    value and strive to protect your privacy in compliance with the Personal Data
                    Protection Act 2010 (As Amended) “PDPA 2010”) and any other applicable laws
                    and regulatory requirements by the relevant governing authorities, with the aim
                    to regulate the collection, holding, processing and use of personal data in
                    commercial transactions.
                </h1>
                <h1>
                    This Privacy Notice regulates how we process your Personal Data, whether
                    directly or indirectly and includes sensitive personal data. The terms, for example
                    “Personal Data”, “Sensitive Personal Data” and “Third Party” whenever referred
                    herein shall have the same meaning ascribed to in the PDPA 2010. For the
                    purposes of this Privacy Notice, “Personal Data” includes but not be limited to
                    your name, address, identification card/passport number, and transaction
                    records with XOX. Meanwhile, “Sensitive Personal Data” comprises information as
                    to your biometric data, physical or mental health or condition, political opinions,
                    religious beliefs or other beliefs of a similar nature, commission or alleged
                    commission of any offence or any other Personal Data as determined by law. XOX
                    reserves the right to change, amend, remove, or add to its privacy policy and/or
                    this Privacy Notice (or any portion of thereof). XOX will endeavour to announce
                    such changes prior to the change taking effect but nevertheless any such
                    announcement will be made available through its
                    webpage <a className="href-color" href="/privacystatement">https://xox.com.my/privacystatement</a>. By continuing to use our
                    services on or after the effective date of such change, you will be deemed to
                    have agreed and accepted these changes. In the event of a conflict, the English
                    version of the Privacy Notice shall prevail over any other version.
                </h1>
                <div className="privacy-notice">
                    <ol className="privacy-list">
                        <li className="privacy-title"> <span>SCOPE</span>
                            <p>
                                This Privacy Notice applies to all XOX operations and business units. To the
                                extent any operations or business unit of XOX already has a personal data
                                protection and/or privacy notice in place; this Privacy Notice shall supersede
                                and replace any such notice.
                            </p>
                        </li>
                        <li className="privacy-title"> <span>RESPONSIBILITY</span>
                            <p>
                                The responsibility on the access and correction of personal data, notice and
                                choice to limit processing of personal data will be managed by XOX resources
                                towards enterprise-wide compliance.
                            </p>
                        </li>
                        <li className="privacy-title"> <span>EFFECTIVE DATE</span>
                            <p>
                                This Privacy Notice is effective as of 1st August, 2013.
                            </p>
                        </li>
                        <li className="privacy-title"> <span>PERSONAL DATA PROTECTION PRINCIPLES</span>
                            <ol>
                                <li className="privacy-subtitle"> <span>General Principle:</span>
                                    <ol className="privacy-subsubtitle">
                                        <li>
                                            XOX will use, process, record, hold, store, share and disclose
                                            (“process”) your Personal Data with your consent.
                                        </li>
                                        <li>
                                            Continuance use of XOX’s services and/or products shall tantamount
                                            to your consent for XOX to process your Personal Data.
                                        </li>
                                        <li>
                                            XOX will record and maintain a record of consent by your continued
                                            use of our services as appearing on our active customer database.
                                        </li>
                                        <li>
                                            If you are under 18 years, it is solely your responsibility to ensure
                                            that you have obtained the consent of your parents or guardian
                                            before subscribing and using our services and/or products. Any
                                            information given to XOX from you as a minor will be processed
                                            accordingly to this Privacy Notice.
                                        </li>
                                    </ol>
                                </li>

                                <li className="privacy-subtitle"> <span>Notice and Choice Principle:</span>
                                    <ol className="privacy-subsubtitle">
                                        <li>
                                            XOX will process and may share the Personal Data for the following
                                            reasons:
                                        </li>

                                        <ul class="abc-list">
                                            <li>
                                                to process account registration;
                                            </li>
                                            <li>
                                                to manage customer’s account;
                                            </li>
                                            <li>
                                                to issue bill statement;
                                            </li>
                                            <li>
                                                to companies and organizations:
                                                <ul class="bullet-list">
                                                    <li>
                                                        for the performance of XOX’s contract of providing
                                                        any goods or services to the customer;
                                                    </li>
                                                    <li>
                                                        for profiling your service preferences;
                                                    </li>
                                                    <li>
                                                        for compliance with any legal and/or regulatory obligations to
                                                        which XOX is subject, in addition to obligations imposed under
                                                        XOX’s contract with the customer;
                                                    </li>
                                                    <li>
                                                        that act as XOX’s payment channels including financial
                                                        institutions for purposes of maintaining financial records,
                                                        assessing or verifying credit and facilitating payments in
                                                        assessing or verifying credit worthiness/standing of any amount
                                                        due to XOX;
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                to other service providers or third parties nominated by XOX either
                                                solely or jointly with other service providers, for purposes of
                                                establishing and maintaining a common database of customers or
                                                processing data as an outsourced entity both within and outside
                                                Malaysia;
                                            </li>
                                            <li>
                                                to interact with and send you information, promotions and updates
                                                including marketing and advertising materials in relation to our
                                                goods and services and those of organizations selected by XOX;
                                            </li>
                                            <li>
                                                to companies and organizations that act as XOX’s agents or
                                                contractors for the purposes of recovering any amount due to XOX;
                                            </li>
                                            <li>
                                                to regulatory bodies or other government authorities in compliance
                                                with requirements under the law or towards the detection or
                                                prevention of crime and/or fraud;
                                            </li>
                                            <li>
                                                to any party involved in or related to a legal proceeding, for
                                                purposes of the proceedings;
                                            </li>
                                            <li>
                                                to protect XOX’s vital interests for the administration of justice;
                                            </li>
                                            <li>
                                                to promote any of XOX’s new or existing products and/or services;
                                                or products, services and special offers of third parties whose
                                                products and services we think may be of interest to you; and;
                                            </li>
                                            <li>
                                                for the exercise of any functions conferred on any person by or
                                                under any law.
                                            </li>
                                            <li>
                                                Biometric data, i.e. face recognition or digital thumbprint.
                                            </li>
                                        </ul>

                                        <li>XOX may collect your Personal Data when you</li>

                                        <ul class="abc-list">
                                            <li>
                                                subscribe or register for one of our services or when you receive
                                                one of XOX services;
                                            </li>
                                            <li>
                                                contact XOX for any reason;
                                            </li>
                                            <li>
                                                participate in any of XOX’s campaign or lucky draw;
                                            </li>
                                            <li>
                                                interact with XOX through various channels including social
                                                media;
                                            </li>
                                            <li>
                                                information is publicly available; or
                                            </li>
                                            <li>
                                                have given other organizations your consent to share or
                                                disclose information about you.
                                            </li>
                                        </ul>
                                        <br />
                                        <p>The types of such information may include:</p>

                                        <ul class="abc-list">
                                            <li>
                                                Contact information such as name, date of birth, identification
                                                number (including NRIC or passport number), gender, nationality
                                                and race, preferred language, current and alternate add
                                            </li>
                                            <li>
                                                The status of the products and/or services you have acquired
                                                from XOX or subscribed to;
                                            </li>
                                            <li>
                                                Traffic data such as number of calls, SMS and other
                                                communication made and received by customer as well as date,
                                                duration, time and cost of such communications;
                                            </li>
                                            <li>
                                                The amount of data received or sent by the customers;
                                            </li>
                                            <li>
                                                Your personal interests and preferences;
                                            </li>
                                            <li>
                                                A record of calls made by you to XOX customer service officers for any queries;
                                            </li>
                                            <li>
                                                Biometric data, which includes any personal data resulting
                                                from technical processing relating to the physical,
                                                physiological or behavioural characteristics of a person.
                                            </li>
                                        </ul>

                                        <li>
                                            Processing outsourced data storage or data processing services for
                                            XOX. XOX and its service providers are based in Malaysia. However,
                                            XOX may transfer your Personal Data to third party service providers
                                            outside Malaysia. While XOX endeavours that such place has similar
                                            personal data provisions to Malaysia, you should also know that such
                                            service providers may have data privacy laws that are different from
                                            Malaysia. Notwithstanding the foregoing, you may request XOX to
                                            transmit your Personal Data (excluding any commercial and/or
                                            technical data, directly or indirectly related to you and which is
                                            confidential to the way XOX does its business or operations) to
                                            another data controller of your choice directly by writing to XOX.
                                        </li>

                                        <li>
                                            If you have provided your Personal Data prior to this Privacy Notice,
                                            you may contact XOX to know what type of Personal Data have been
                                            processed and the purpose for the processing.
                                        </li>

                                        <li>
                                            Save in accordance with this Privacy Notice and except as permitted
                                            or required under any enactment, law, statute, or code, XOX will not
                                            use or disclose your Personal Data without prior written consent from
                                            you.
                                        </li>

                                        <li>
                                            You will be given the opportunity to ‘opt-out’ of having your
                                            Personal Data used for purposes not directly related to the Services or
                                            XOX’s Websites at the point where XOX asks for information. If you do
                                            not wish to receive our promotional updates, you may opt-out of
                                            receiving these communications by contacting XOX at the contact
                                            numbers listed below. But please note that should you decide to “opt-out”,
                                            we may not be able to provide you with certain services and
                                            your subscription to or application for certain services may be
                                            declined, denied, or refused by XOX.
                                        </li>

                                        <li>
                                            Your right to limit processing of your Personal Data. At any time,
                                        </li>

                                        <ul class="abc-list">
                                            <li>
                                                You may request for XOX to suspend or limit any processing of
                                                your Personal Data if you have concerns of the legitimacy of
                                                such processing activity. During the temporary suspension
                                                period, certain provision of XOX’s services may be affected; or
                                            </li>
                                            <li>
                                                You may request for XOX to cease altogether any processing
                                                activities of your Personal Data for any purpose.
                                            </li>
                                        </ul>

                                        <li>
                                            XOX is obliged to disclose your cell phone number to other network
                                            operators to enable the use of the services. Should you refuse to
                                            permit such disclosure, XOX may not be able to continue providing
                                            you with certain services.
                                        </li>
                                    </ol>
                                </li>
                                <li className="privacy-subtitle"> <span>Disclosure Principle:</span>
                                    <ol className="privacy-subsubtitle">
                                        <li>
                                            XOX will only disclose Personal Data to comply with any government
                                            agency notification requirements; and/or for the purpose for which the
                                            Personal Data is processed where you have consented to disclosure,
                                            including disclosure of data to any Credit Reporting Agencies
                                            registered under the Credit Reporting Agencies Act 2010.
                                        </li>

                                        <li>
                                            XOX may from time to time, contact you on behalf of external
                                            business partners about particular goods, offers or services that may
                                            be of interest to you.
                                        </li>

                                        <li>
                                            XOX may disclose your Personal Data to subsidiaries, its parent
                                            company XOX BHD or any other entity for the purpose as outlined in
                                            paragraph 4.2.1 (if any).
                                        </li>
                                    </ol>
                                </li>
                                <li>Security Principle:
                                    <p>
                                        XOX is responsible for taking prudent steps to safeguard the
                                        confidentiality and security of all Personal Data, including appropriate
                                        procedural, organizational and technical steps to protect personal data
                                        from accidental or unlawful destruction or accidental loss, alteration or
                                        disclosure. These steps include entering into written agreements with
                                        subcontractors who process Personal Data in accordance with XOX’s
                                        instructions and incorporating XOX’s own data protection standards as a
                                        minimum.
                                    </p>
                                </li>
                                <li className="privacy-subtitle"> <span>Retention Principle:</span>
                                    <p>
                                        XOX will retain your Personal Data for as long as there exists a purpose for
                                        which it was collected and processed. XOX will also retain your Personal
                                        Data to comply with any legal, regulatory or XOX’s internal requirements.
                                        A number of safeguards, appropriate to the sensitivity of the information,
                                        to protect Personal Data against loss or theft, as well as unauthorized
                                        access, disclosure, copying, use, or modification is practiced by XOX.
                                        Upon termination of service or account closure, Customer account data
                                        will be archived for two (2) years for reasons above mentioned. Once the
                                        purpose for which your Personal Data is collected is no longer necessary,
                                        XOX will take all reasonable steps to destroy or permanently delete both
                                        physical and electronic copies containing your Personal Data.
                                    </p>
                                </li>
                                <li className="privacy-subtitle"> <span>Data Integrity Principle:</span>
                                    <ol className="privacy-subsubtitle">
                                        <li>
                                            XOX strives to maintain complete, current, and accurate information
                                            about its customers. Any inaccurate information that is brought to
                                            XOX’s attention will be corrected as quickly as possible after
                                            notification.
                                        </li>

                                        <li>
                                            You can also request from XOX to amend, correct or update your
                                            Personal Data that is inaccurate or outdated.
                                        </li>

                                        <li>
                                            Procedures will be maintained to ensure that any reported
                                            inaccuracies are promptly and effectively handled, and that
                                            customers’ information remains as accurate, current and complete as
                                            possible. The Personal Data correction / update form may be
                                            requested by email to <a href="mailto:enquiries@xox.com.my">enquiries@xox.com.my</a>
                                        </li>
                                    </ol>
                                </li>
                                <li className="privacy-subtitle"> <span>Access Principle:</span>
                                    <ol className="privacy-subsubtitle">
                                        <li>
                                            At all times, you have the right to access your information.
                                        </li>

                                        <li>
                                            At any point of time, you can request from XOX a copy of your
                                            Personal Data that XOX holds about you for a prescribed fee pursuant
                                            to the Personal Data Protection Code of Practice – For Licensees under
                                            The Communications and Multimedia Act 1998.
                                        </li>
                                    </ol>
                                </li>
                            </ol>
                        </li>
                        <li className="privacy-title"><span>SENSITIVE PERSONAL DATA</span>
                            <ol>
                                <li>
                                    XOX does not process any Sensitive Personal Data in its ordinary
                                    course of business.
                                </li>

                                <li>
                                    If need arises, XOX will obtain explicit consent from you before or
                                    when it processes Sensitive Personal Data.
                                </li>

                                <li>
                                    XOX may process Personal Data or Sensitive Personal Data without
                                    the customer’s consent only in limited circumstances as permitted by law.
                                    Such circumstances are strictly for XOX to fulfil its legal and compliance
                                    obligations, including adherence to industry regulations, such as those
                                    related to data protection, consumer protection, and anti-money
                                    laundering, or law enforcement cooperation, including assisting law
                                    enforcement agencies in investigations
                                </li>
                            </ol>
                        </li>
                        <li className="privacy-title"><span>XOX’S WEBSITE</span>
                            <ol>
                                <li>
                                    Notwithstanding XOX offers its products and services via its various
                                    platform, with XOX’s website being one, when you visit XOX’s websites the
                                    web servers generally record anonymous information such as the time,
                                    date and URL of the request. This information assists XOX to improve the
                                    structure of its websites and monitor their performance. From time-to-time
                                    XOX may also use third parties to analyse this anonymous
                                    information.
                                </li>

                                <li>
                                    As mandatory in the usage of the XOX’s websites XOX may require
                                    standard information such as a user or customer’s login identification,
                                    password, Personal Data for verification purposes, contact details and
                                    identification numbers. This information is necessary for XOX to provide
                                    the services you applied for. You are required to maintain the secrecy of
                                    your login identification and password to access the XOX home page.
                                </li>
                            </ol>
                        </li>
                        <li className="privacy-title"><span>IP ADDRESSES AND COOKIES</span>
                            <ol>
                                <li>
                                    XOX also collects internet protocol (IP) addresses. XOX collects and
                                    manages IP addresses as part of the service of providing internet session
                                    management and for security purposes.
                                </li>

                                <li>
                                    XOX’s websites may transmit to your computer a “cookie” to allow
                                    XOX’s server to identify and interact more effectively with you. You may
                                    configure and personalize its current browser to refuse, reject or delete
                                    such cookies.
                                </li>
                            </ol>
                        </li>
                        <li className="privacy-title"><span>INTEREST BASED ADVERTISING</span>
                            <ol>
                                <li>
                                    XOX collects anonymous information about your web browsing
                                    activity from your internet-enabled device and use that information to
                                    associate your browser with one or more pre-defined interest categories.
                                    This enables XOX to provide ads to you that are tailored to your interests.
                                </li>

                                <li>
                                    You may configure and personalize your current browser to refuse,
                                    reject or delete collection of information for internet-based advertising.
                                </li>
                            </ol>
                        </li>
                        <li className="privacy-title"><span>CALLING NUMBER DISPLAY</span>
                            <p>
                                XOX’s Calling Number Display facility (CND) lets persons who receive phone
                                calls identify who is calling them by displaying the caller’s number. CND
                                forms part of the ordinary telephony service that you purchase from XOX.
                                Unless you have chosen to block your (home or mobile) phone number, or
                                have a silent line, CND will usually cause your phone number to be displayed
                                (or logged) – locally and sometimes internationally – on a receiving caller’s
                                phone. In other words, CND will enable the disclosure of your phone number
                                to receive callers (and to other network operators) locally and internationally,
                                unless you take the above measures.
                            </p>
                        </li>
                        <li className="privacy-title"><span>XOX CONTACT DETAILS</span>
                            <p>
                                If you have any inquiries, concern or complaint about this Privacy Notice, XOX
                                is contactable as follows:  <br />
                                Telephone (8am to 10pm, including Saturdays, Sundays & State/Public Holidays):<br />
                                From XOX Digital 12273 / From Malaysia 1300 888 010 /<br />
                                From abroad +603 7800 0033<br />
                                <br />
                                E-mail (Monday to Friday 9am to 6pm, office operation hours only):<br />
                                <a href="mailto:xoxregulatory@xox.com.my">xoxregulatory@xox.com.my</a><br />
                                Attn.: Data Protection Officer (DPO)  <br />
                                <br />
                                Address (Monday to Friday 9am to 6pm, office operation hours only for physical attendance):<br />
                                Lot 17.1, 17th Floor, Menara Lien Hoe, No. 8,<br />
                                Persiaran Tropicana, Tropicana Golf & Country Resort,<br />
                                47410 Petaling Jaya, Selangor Darul Ehsan.<br />
                                <br />
                                <b>We're here to assist with matters relating to this Privacy Notice,
                                    your Personal Data, and your data protection rights. If you need help
                                    with XOX products or services, such as subscriptions, billing, mobile
                                    lines, network coverage, technical support, or other service-related
                                    enquiries, please contact our <a className="href-color" target="_blank" href="https://onexox.my/hubungi-kami">Customer Service team</a> through the
                                    appropriate support channels for assistance.</b>
                                <br />
                                <br />
                                <b>Updated as of 23rd September 2026.</b>
                            </p>
                        </li>
                    </ol>
                </div>
            </div>

            <div className="privacy_content">

                <h3> Notis Privasi XOX </h3>
                <h1>
                    Notis Privasi dimaklumkan untuk dan bagi pihak XOX BHD dan kumpulan
                    syarikat XOX (selepas ini dirujuk sebagai “XOX”, atau “kami”). Kami menghargai
                    data peribadi anda dan berusaha untuk melindungi maklumat peribadi anda
                    dibawah Akta Perlindungan Data Peribadi 2010 (sepertimana dipinda) dan garis
                    panduan berkaitan yang dikeluarkan oleh agensi kawal selia (secara kolektif
                    selepas ini dirujuk sebagai “APDP 2010”) yang bertujuan untuk mengawal
                    pengumpulan, penyimpanan, pemprosesan and penggunaan maklumat peribadi
                    dalam sebarang transaksi komersial.
                </h1>
                <h1>
                    Notis Privasi ini mengawal cara kami memproses Data Peribadi anda, sama ada
                    secara langsung atau tidak langsung dan termasuk data peribadi yang sensitif.
                    Terma-terma, contohnya “Data Peribadi”, “Data Peribadi Sensitif” dan “Pihak
                    Ketiga” apabila dirujuk di sini mempunyai makna yang sama seperti yang
                    dinyatakan dalam APDP 2010. Bagi tujuan Notis Privasi ini, “Data Peribadi”
                    termasuk tetapi tidak terhad kepada nama, alamat, nombor kad
                    pengenalan/pasport dan rekod transaksi di antara anda dan XOX. Sementara itu,
                    “Data Peribadi Sensitif” terdiri daripada maklumat tentang kesihatan atau
                    keadaan fizikal atau mental anda, pendapat politik, kepercayaan agama atau
                    kepercayaan lain yang serupa sifat, perlakuan atau tuduhan perbuatan
                    kesalahan atau mana-mana Data Peribadi lain yang ditentukan oleh undang-
                    undang.
                </h1>
                <h1>
                    XOX berhak untuk menukar, meminda, mengeluarkan atau menambah dasar
                    privasinya dan/atau Notis Privasi ini (atau mana-mana bahagian daripadanya).
                    XOX akan berusaha untuk mengumumkan perubahan tersebut sebelum ianya
                    berkuat kuasa. Walau bagaimanpun, sebarang pengumuman mengenai
                    perubahan akan dimaklumkan melalui laman
                    web <a href="/privacystatement">https://xox.com.my/privacystatement</a>. Dengan terus menggunakan
                    perkhidmatan kami pada atau selepas tarikh kuat kuasa perubahan tersebut,
                    anda akan dianggap telah bersetuju dan menerima perubahan ini. Sekiranya
                    berlaku konflik, versi Bahasa Inggeris Notis Privasi akan mengatasi mana-mana
                    versi lain.
                </h1>

                <div className="privacy-notice">
                    <ol className="privacy-list">
                        <li className="privacy-title"> <span>SKOP</span>
                            <p>
                                Notis ini tertakluk kepada semua operasi dan unit perniagaan di XOX.
                                Sekiranya mana-mana unit operasi atau unit perniagaan XOX telah
                                mempunyai notis perlindungan data peribadi dan/atau notis privasi, Notis ini
                                akan mengambil tempat dan menggantikan mana-mana notis tersebut.
                            </p>
                        </li>
                        <li className="privacy-title"> <span>TANGGUNGJAWAB</span>
                            <p>
                                Tanggungjawab mengenai akses dan pembetulan data peribadi, notis dan
                                pilihan untuk mengehadkan pemprosesan data peribadi akan diuruskan oleh
                                XOX ke arah pematuhan bagi seluruh organisasi.
                            </p>
                        </li>
                        <li className="privacy-title"> <span>TARIKH EFEKTIF</span>
                            <p>Notis Privasi ini berkuat kuasa mulai 1 Ogos 2013.</p>
                        </li>
                        <li className="privacy-title"> <span>PRINSIP PERLINDUNGAN DATA PERIBADI</span>
                            <ol>
                                <li className="privacy-subtitle"> <span>Prinsip Umum:</span>
                                    <ol className="privacy-subsubtitle">
                                        <li>
                                            XOX akan menggunakan, memproses, merekod, memegang,
                                            menyimpan, berkongsi dan menzahirkan (“proses”) Data Peribadi
                                            dengan kebenaran anda.
                                        </li>
                                        <li>
                                            Sebarang penggunaan perkhidmatan dan/atau produk XOX yang
                                            berterusan akan dianggap sebagai kebenaran untuk XOX memproses
                                            Data Peribadi anda.
                                        </li>
                                        <li>
                                            XOX akan merakam dan menyimpan rekod persetujuan anda bagi
                                            meneruskan penggunaan perkhidmatan kami seperti yang tertera di
                                            pangkalan data pelanggan aktif kami.
                                        </li>
                                        <li>
                                            Jika anda berumur di bawah 18 tahun, ia menjadi tanggungjawab
                                            anda sepenuhnya untuk memastikan bahawa anda telah mendapat
                                            kebenaran ibu bapa atau penjaga anda sebelum melanggan dan
                                            menggunakan perkhidmatan dan/atau produk kami. Sebarang
                                            maklumat yang diberikan kepada XOX daripada anda sebagai kanak-kanak
                                            di bawah umur akan diproses mengikut Notis Privasi ini.
                                        </li>
                                    </ol>
                                </li>

                                <li className="privacy-subtitle"> <span> Prinsip Notis dan Pilihan:</span>
                                    <ol className="privacy-subsubtitle">
                                        <li>
                                            XOX akan memproses dan mungkin berkongsi Data Peribadi atas
                                            sebab-sebab berikut:-
                                        </li>

                                        <ul class="abc-list">
                                            <li>
                                                untuk memproses pendaftaran akaun;
                                            </li>
                                            <li>
                                                untuk menguruskan akaun pelanggan;
                                            </li>
                                            <li>
                                                untuk mengeluarkan penyata bil;
                                            </li>
                                            <li>
                                                untuk syarikat dan organisasi
                                                <ul class="bullet-list">
                                                    <li>
                                                        untuk melaksanakan kontrak XOX dalam
                                                        memberikan sebarang produk atau perkhidmatan
                                                        kepada pelanggan;
                                                    </li>
                                                    <li>
                                                        untuk memprofilkan pilihan perkhidmatan anda;
                                                    </li>
                                                    <li>
                                                        untuk pematuhan mana-mana kewajipan undang-undang
                                                        dan/atau kawal selia yang XOX tertakluk, sebagai tambahan
                                                        kepada sebarang kewajipan yang dikenakan di bawah kontrak
                                                        XOX dengan pelanggan;
                                                    </li>
                                                    <li>
                                                        yang bertindak sebagai saluran pembayaran XOX termasuk dan
                                                        tanpa had, institusi kewangan untuk tujuan mengekalkan rekod
                                                        kewangan, menilai atau mengesahkan kredit dan memudahkan
                                                        pembayaran dalam menilai atau mengesahkan
                                                        kelayakan/kedudukan kredit bagi sebarang jumlah terhutang
                                                        kepada XOX;
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                kepada pembekal perkhidmatan lain atau pihak ketiga yang
                                                dicalonkan oleh XOX sama ada secara bersendirian atau bersama
                                                dengan pembekal perkhidmatan yang lain, untuk tujuan
                                                mewujudkan dan mengekalkan pangkalan data bersama
                                                pelanggan atau memproses data sebagai entiti penyumberan
                                                luar di dalam dan di luar Malaysia;
                                            </li>
                                            <li>
                                                untuk berinteraksi dan menghantar maklumat, promosi dan
                                                kemas kini kepada anda termasuk bahan pemasaran dan
                                                pengiklanan berhubung dengan barangan dan perkhidmatan
                                                kami dan organisasi yang dipilih oleh XOX;
                                            </li>
                                            <li>
                                                kepada syarikat dan organisasi yang bertindak sebagai ejen atau
                                                kontraktor XOX untuk tujuan mendapatkan semula sebarang
                                                jumlah terhutang kepada XOX;
                                            </li>
                                            <li>
                                                kepada badan kawal selia atau pihak berkuasa kerajaan yang lain
                                                dengan mematuhi keperluan di bawah undang-undang atau ke
                                                arah pengesanan atau pencegahan jenayah dan/atau penipuan;
                                            </li>
                                            <li>
                                                kepada mana-mana pihak yang terlibat dalam atau berkaitan
                                                dengan prosiding undang-undang, untuk tujuan prosiding;
                                            </li>
                                            <li>
                                                untuk melindungi kepentingan XOX demi pentadbiran keadilan;
                                            </li>
                                            <li>
                                                untuk mempromosikan mana-mana produk dan/atau
                                                perkhidmatan XOX yang baru atau sedia ada; atau produk,
                                                perkhidmatan dan tawaran istimewa pihak ketiga yang produk
                                                dan perkhidmatannya kami percaya mungkin menarik minat
                                                anda; dan;
                                            </li>
                                            <li>
                                                untuk menjalankan apa-apa fungsi yang diberikan kepada
                                                mana-mana orang oleh atau di bawah mana-mana undang-undang;
                                            </li>
                                            <li>
                                                data biometrik, e.g. pengecaman muka atau cap ibu jari
                                                digital.
                                            </li>
                                        </ul>

                                        <li>XOX akan mengumpul Data Peribadi apabila anda:</li>

                                        <ul class="abc-list">
                                            <li>
                                                melanggan atau mendaftar untuk salah satu perkhidmatan kami
                                                atau apabila anda menerima salah satu perkhidmatan XOX;
                                            </li>
                                            <li>
                                                menghubungi XOX atas sebarang sebab;
                                            </li>
                                            <li>
                                                menyertai mana-mana kempen atau cabutan bertuah XOX;
                                            </li>
                                            <li>
                                                berinteraksi dengan XOX melalui pelbagai saluran termasuk
                                                media sosial;
                                            </li>
                                            <li>
                                                maklumat tersedia secara umum; atau
                                            </li>
                                            <li>
                                                telah memberikan persetujuan anda kepada organisasi lain
                                                untuk berkongsi atau mendedahkan maklumat anda.
                                            </li>
                                        </ul>
                                        <br />
                                        <p>Jenis maklumat tersebut mungkin meliputi:</p>

                                        <ul class="abc-list">
                                            <li>
                                                Maklumat untuk dihubungi seperti nama, tarikh lahir, nombor
                                                pengenalan (termasuk NRIC atau nombor pasport), jantina,
                                                warganegara dan bangsa, bahasa pilihan, alamat semasa dan
                                                alternatif, nombor telefon atau nombor talian mudah alih, nombor
                                                faks, alamat emel;
                                            </li>
                                            <li>
                                                status produk dan/atau perkhidmatan yang diperolehi atau
                                                dilanggan oleh pelanggan dari XOX;
                                            </li>
                                            <li>
                                                data trafik seperti jumlah panggilan, SMS dan dan komunikasi lain
                                                yang dilakukan dan diterima oleh pelanggan berserta tarikh, durasi,
                                                masa dan kos bagi komunikasi tersebut;
                                            </li>
                                            <li>
                                                jumlah data yang diterima atau dihantar oleh pelanggan;
                                            </li>
                                            <li>
                                                pilihan dan minat peribadi pelanggan;
                                            </li>
                                            <li>
                                                rekod panggilan yang dilakukan oleh pelanggan kepada pegawai
                                                khidmat pelanggan XOX bagi sebarang pertanyaan.
                                            </li>
                                            <li>
                                                biometrik data yang merangkumi sebarang data peribadi hasil
                                                daripada pemprosesan teknikal yang berkaitan dengan ciri fizikal,
                                                fisiologi atau tingkah laku seseorang.
                                            </li>
                                        </ul>

                                        <li>
                                            XOX dan pembekal perkhidmatannya berpangkalan di Malaysia.
                                            Walau bagaimanapun, XOX boleh memindahkan Data Peribadi anda
                                            kepada pembekal perkhidmatan pihak ketiga di luar Malaysia.
                                            Walaupun XOX berusaha supaya tempat tersebut mempunyai
                                            peruntukan kawal selia data peribadi yang serupa dengan Malaysia,
                                            anda juga harus tahu bahawa pembekal perkhidmatan tersebut
                                            mungkin mempunyai undang-undang privasi data yang berbeza
                                            daripada Malaysia. Walau apa pun yang tersebut di atas, anda boleh
                                            meminta XOX untuk menghantar Data Peribadi anda (tidak termasuk
                                            sebarang data komersial dan/atau teknikal, secara langsung atau
                                            tidak langsung berkaitan dengan anda dan yang dirahsiakan dengan
                                            cara XOX menjalankan perniagaan atau operasinya) kepada pengawal
                                            data lain pilihan anda secara terus dengan menulis kepada XOX.
                                        </li>

                                        <li>
                                            Jika anda telah memberikan Data Peribadi anda sebelum Notis
                                            Privasi ini, anda boleh menghubungi XOX untuk mengetahui jenis
                                            Data Peribadi yang telah diproses dan tujuan pemprosesan.
                                        </li>

                                        <li>
                                            Selain daripada perkara yang termaktub di dalam Notis ini dan
                                            melainkan apa yang dibenarkan atau dikehendaki di bawah mana-mana
                                            enakmen, undang-undang, statut atau kod, XOX tidak akan
                                            menggunakan atau mendedahkan Data Peribadi tanpa sebarang
                                            kebenaran bertulis daripada anda.
                                        </li>

                                        <li>
                                            Anda boleh memilih untuk tidak membenarkan Data Peribadi anda
                                            digunakan untuk tujuan yang tidak berkaitan secara langsung dengan
                                            Perkhidmatan atau Laman sesawang XOX yang mana XOX akan
                                            bertanyakan mengenai pengesahan maklumat tersebut kepada anda.
                                            Jika anda tidak mahu menerima maklumat promosi, anda boleh
                                            menghubungi XOX menggunakan nombor yang tertera di bawah.
                                            Namun demikian, untuk makluman sekiranya anda memilih untuk
                                            tidak menerima maklumat di atas, kami mungkin tidak dapat
                                            menyediakan Perkhidmatan yang tertentu kepada anda. Langganan
                                            anda atau sebarang permohonan Perkhidmatan yang tertentu
                                            mungkin akan ditolak atau dinafikan atau tidak dapat diakses oleh
                                            XOX.
                                        </li>

                                        <li>
                                            Hak anda untuk mengehadkan pemprosesan Data Peribadi anda.
                                            Pada bila bila masa,
                                        </li>

                                        <ul class="abc-list">
                                            <li>
                                                Anda boleh meminta XOX untuk menggantung atau
                                                mengehadkan sebarang pemprosesan Data Peribadi anda jika
                                                anda mempunyai kebimbangan tentang kesahihan aktiviti
                                                pemprosesan tersebut. Semasa tempoh penggantungan
                                                sementara, peruntukan tertentu bagi perkhidmatan XOX mungkin
                                                terjejas; atau
                                            </li>
                                            <li>
                                                Anda boleh meminta XOX untuk menghentikan sama sekali
                                                sebarang aktiviti pemprosesan Data Peribadi anda untuk apa jua
                                                tujuan.
                                            </li>
                                        </ul>

                                        <li>
                                            XOX bertanggungjawab untuk menzahirkan nombor telefon bimbit
                                            anda kepada pengendali rangkaian lain untuk membolehkan
                                            penggunaan perkhidmatan tersebut. Sekiranya anda enggan
                                            membenarkan penzahiran tersebut, XOX mungkin tidak dapat terus
                                            menyediakan perkhidmatan yang tertentu kepada anda.
                                        </li>
                                    </ol>
                                </li>
                                <li className="privacy-subtitle"> <span>Prinsip Penzahiran:</span>
                                    <ol className="privacy-subsubtitle">
                                        <li>
                                            XOX hanya akan mendedahkan Data Peribadi untuk mematuhi
                                            sebarang keperluan pemberitahuan agensi kerajaan; dan/atau untuk
                                            tujuan Data Peribadi diproses di mana anda telah bersetuju untuk
                                            mendedahkan, termasuk pendedahan data kepada mana-mana
                                            Agensi Pelaporan Kredit yang didaftarkan di bawah Akta Agensi
                                            Pelaporan Kredit 2010.
                                        </li>

                                        <li>
                                            XOX boleh dari semasa ke semasa, menghubungi anda bagi pihak
                                            rakan kongsi perniagaan luar mengenai produk, tawaran atau
                                            perkhidmatan tertentu yang mungkin menarik minat anda.
                                        </li>

                                        <li>
                                            XOX akan menzahirkan Data Peribadi anda kepada anak syarikat
                                            dibawah XOX, atau sebarang entiti untuk tujuan seperti tertera di
                                            perenggan 4.2.1 (sekiranya ada).
                                        </li>
                                    </ol>
                                </li>
                                <li>Prinsip Keselamatan:
                                    <p>
                                        XOX bertanggungjawab untuk mengambil langkah berhemah bagi
                                        melindungi kerahsiaan dan keselamatan semua Data Peribadi, termasuk
                                        langkah prosedur, organisasi dan teknikal yang sesuai untuk melindungi
                                        data peribadi daripada kemusnahan secara tidak sengaja atau menyalahi
                                        undang-undang atau kehilangan, pengubahan atau penzahiran secara
                                        tidak sengaja. Langkah-langkah ini termasuk membuat perjanjian bertulis
                                        dengan subkontraktor yang memproses Data Peribadi menurut arahan
                                        XOX dan memasukkan standard perlindungan data XOX sendiri sebagai
                                        standard minimum.
                                    </p>
                                </li>
                                <li className="privacy-subtitle"> <span>Prinsip Penyimpanan:</span>
                                    <p>
                                        XOX akan mengekalkan Data Peribadi anda selagi tujuan ia dikumpul dan
                                        diproses wujud. XOX juga akan mengekalkan Data Peribadi anda untuk
                                        mematuhi mana-mana undang-undang, peraturan atau keperluan
                                        dalaman XOX. Sebilangan perlindungan, bersesuaian dengan sensitiviti
                                        maklumat, untuk melindungi Data Peribadi daripada kehilangan atau
                                        kecurian, serta akses tanpa kebenaran, penzahiran, penyalinan,
                                        penggunaan atau pengubahsuaian diamalkan oleh XOX. Selepas
                                        penamatan perkhidmatan atau penutupan akaun, data akaun Pelanggan
                                        akan diarkibkan selama dua (2) tahun atas sebab yang dinyatakan di
                                        atas. Sebaik sahaja tujuan Data Peribadi anda dikumpul tidak lagi
                                        diperlukan, XOX akan mengambil semua langkah yang munasabah untuk
                                        memusnahkan atau memadamkan Data Peribadi anda secara kekal.
                                    </p>
                                </li>
                                <li className="privacy-subtitle"> <span>Prinsip Integriti Data:</span>
                                    <ol className="privacy-subsubtitle">
                                        <li>
                                            XOX berusaha untuk mengekalkan maklumat yang lengkap, terkini
                                            dan tepat tentang pelanggannya. Sebarang maklumat yang tidak
                                            tepat yang dibawa ke perhatian XOX akan diperbetulkan secepat
                                            mungkin selepas pemberitahuan.
                                        </li>

                                        <li>
                                            Anda juga boleh meminta daripada XOX untuk meminda,
                                            membetulkan atau mengemas kini Data Peribadi anda yang tidak
                                            tepat atau lapuk.
                                        </li>

                                        <li>
                                            Prosedur akan dikekalkan untuk memastikan bahawa sebarang
                                            ketidaktepatan yang dilaporkan dikendalikan dengan segera dan
                                            berkesan, dan maklumat pelanggan kekal tepat, terkini dan selengkap
                                            mungkin. Borang pembetulan / kemas kini Data Peribadi boleh diminta
                                            melalui capaian e-mel ke <a href="mailto:enquiries@xox.com.my">enquiries@xox.com.my</a>
                                        </li>
                                    </ol>
                                </li>
                                <li className="privacy-subtitle"> <span>Prinsip Akses:</span>
                                    <ol className="privacy-subsubtitle">
                                        <li>
                                            Pada setiap masa, anda mempunyai hak untuk mengakses
                                            maklumat anda.
                                        </li>

                                        <li>
                                            Pada bila-bila masa, anda boleh meminta daripada XOX salinan Data
                                            Peribadi anda yang XOX simpan pada kadar bayaran seperti yang
                                            ditetapkan menurut Kod Amalan Perlindungan Data Peribadi – Untuk
                                            Pemegang Lesen di bawah Akta Komunikasi Dan Multimedia 1998.
                                        </li>
                                    </ol>
                                </li>
                            </ol>
                        </li>
                        <li className="privacy-title"><span>DATA PERIBADI SENSITIF</span>
                            <ol>
                                <li>
                                    XOX tidak memproses sebarang Data Peribadi Sensitif dalam urusan
                                    perniagaan sehariannya.
                                </li>

                                <li>
                                    Jika perlu, XOX akan mendapatkan kebenaran yang eksplisit
                                    daripada pelanggan sebelum atau ketika Data Peribadi Sensitif diproses.
                                </li>

                                <li>
                                    Data Peribadi dan Data Peribadi Sensitif pelanggan mungkin akan
                                    diproses oleh XOX tanpa kebenaran pelanggan hanya jika dalam keadaan
                                    yang sah di sisi undang-undang. Keadaan sedemikian adalah untuk XOX
                                    memenuhi kewajipan undang-undang dan pematuhannya, termasuk
                                    pematuhan kepada peraturan industri, seperti yang berkaitan dengan
                                    perlindungan data, perlindungan pengguna dan pencegahan pengubahan
                                    wang haram, atau kerjasama penguatkuasaan undang-undang, termasuk
                                    membantu agensi penguatkuasaan undang-undang dalam penyiasatan.
                                </li>
                            </ol>
                        </li>
                        <li className="privacy-title"><span>LAMAN SESAWANG XOX</span>
                            <ol>
                                <li>
                                    Walaupun XOX menawarkan produk dan perkhidmatannya melalui
                                    pelbagai platformnya, dengan laman sesawang XOX menjadi satu, apabila
                                    anda melayari laman sesawang XOX, biasanya akan menyimpan
                                    maklumat tersembunyi pelayar laman sesawang XOX seperti masa, tarikh
                                    dan URL yang dicari. Maklumat ini membantu XOX untuk memperbaiki
                                    struktur dan memantau perlaksanaan laman sesawang kami. Dari masa
                                    ke semasa, XOX akan menggunakan perkhidmatan pihak ketiga dalam
                                    menganalisa maklumat tanpa nama/tersembunyi ini.
                                </li>

                                <li>
                                    Sebagai syarat mandatori dalam penggunaan laman sesawang XOX,
                                    XOX mungkin memerlukan maklumat standard seperti pengenalan log
                                    masuk pengguna atau pelanggan, kata laluan, Data Peribadi untuk tujuan
                                    pengesahan, maklumat perhubungan dan nombor pengenalan diri.
                                    Maklumat ini diperlukan untuk XOX menyediakan perkhidmatan yang
                                    anda mohon. Anda dikehendaki mengekalkan kerahsiaan pengenalan log
                                    masuk dan kata laluan anda untuk mengakses halaman utama XOX.
                                </li>
                            </ol>
                        </li>
                        <li className="privacy-title"><span>ALAMAT IP DAN COOKIES</span>
                            <ol>
                                <li>
                                    XOX juga mengumpul alamat protokol internet (“IP”). XOX
                                    mengumpul dan mengurus alamat IP sebagai sebahagian daripada
                                    perkhidmatan menyediakan pengurusan sesi internet dan untuk tujuan
                                    keselamatan.
                                </li>

                                <li>
                                    Laman sesawang XOX mungkin menghantar “cookie” ke komputer
                                    anda untuk membolehkan “server” XOX mengenal pasti dan berinteraksi
                                    dengan anda dengan lebih berkesan. Anda boleh mengkonfigurasi dan
                                    memperibadikan pelayar semasanya untuk menafikan, menyahaktifkan
                                    tetapan atau memadamkan “cookie” tersebut.
                                </li>
                            </ol>
                        </li>
                        <li className="privacy-title"><span>PENGIKLANAN BERDASARKAN KEGEMARAN</span>
                            <ol>
                                <li>
                                    XOX mengumpul maklumat tanpa nama tentang aktiviti
                                    penyemakan imbas laman sesawang anda daripada peranti berdaya
                                    internet anda dan menggunakan maklumat tersebut untuk mengaitkan
                                    penyemak imbas anda dengan satu atau lebih kategori minat yang telah
                                    ditetapkan. Ini membolehkan XOX menyediakan iklan kepada anda yang
                                    disesuaikan dengan minat anda.
                                </li>

                                <li>
                                    Anda boleh mengkonfigurasi dan memperibadikan pelayar semasa
                                    anda untuk menafikan, menolak atau memadam pengumpulan maklumat
                                    untuk pengiklanan berasaskan internet.
                                </li>
                            </ol>
                        </li>
                        <li className="privacy-title"><span>PAPARAN NOMBOR PANGGILAN</span>
                            <p>
                                Kemudahan Paparan Nombor Panggilan (“CND”) XOX membolehkan orang
                                yang menerima panggilan telefon mengenal pasti siapa yang memanggil
                                mereka dengan memaparkan nombor pemanggil. CND merupakan
                                sebahagian daripada perkhidmatan telefon biasa yang anda beli daripada
                                XOX. Melainkan anda telah memilih untuk menyekat nombor telefon (rumah
                                atau mudah alih) anda, atau mempunyai talian senyap, CND biasanya akan
                                menyebabkan nombor telefon anda dipaparkan (atau dilog) – secara
                                tempatan dan kadangkala di peringkat antarabangsa – pada telefon
                                pemanggil yang menerima. Dalam erti kata lain, CND akan membolehkan
                                pendedahan nombor telefon anda untuk menerima pemanggil (dan kepada
                                pengendali rangkaian lain) secara tempatan dan antarabangsa, melainkan
                                anda mengambil langkah seperti di atas.
                            </p>
                        </li>
                        <li className="privacy-title"><span>HUBUNGI XOX</span>
                            <p>
                                Jika anda mempunyai sebarang pertanyaan, kebimbangan atau aduan tentang Notis Privasi ini, XOX boleh dihubungi seperti berikut:
                                <br />
                                Telefon (8 pagi hingga 10 malam, termasuk Sabtu, Ahad & Cuti Negeri/Umum):<br />
                                Dari XOX Digital 12273 / Dari Malaysia 1300 888 010 /<br />
                                Dari luar negara +603 7800 0033<br />
                                <br />
                                E-mel (Isnin hingga Jumaat 9 pagi hingga 6 petang, waktu operasi pejabat sahaja):<br />
                                <a href="mailto:xoxregulatory@xox.com.my">xoxregulatory@xox.com.my</a><br />
                                U/P.: Pegawai Perlindungan Data (DPO)<br />
                                <br />
                                Alamat (Isnin hingga Jumaat 9 pagi hingga 6 petang, waktu operasi pejabat hanya untuk kehadiran fizikal):<br />
                                Lot 17.1, Tingkat 17, Menara Lien Hoe, No. 8,<br />
                                Persiaran Tropicana, Tropicana Golf & Country Resort,<br />
                                47410 Petaling Jaya, Selangor Darul Ehsan. <br />
                                <br />
                                <b>Kami sedia membantu berkenaan perkara yang berkaitan dengan
                                    Notis Privasi ini, Data Peribadi anda, dan hak perlindungan data
                                    anda. Sekiranya anda memerlukan bantuan berkaitan produk atau
                                    perkhidmatan XOX, seperti langganan, bil, talian mudah alih, liputan
                                    rangkaian, sokongan teknikal, atau pertanyaan berkaitan
                                    perkhidmatan yang lain, sila hubungi <a className="href-color" target="_blank" href="https://onexox.my/hubungi-kami">Khidmat Pelanggan</a> kami
                                    melalui saluran sokongan yang berkaitan bagi mendapatkan
                                    bantuan.  </b>
                                <br />
                                <br />
                                <b>Dikemaskini pada 23hb Sep 2026, dan jika berlakunya sebarang pertikaian antara versi Bahasa Inggeris dan versi bahasa lain,
                                    versi Bahasa Inggeris akan diguna pakai.</b>
                            </p>
                        </li>
                    </ol>
                </div>
            </div>



            <div style={{ padding: "0px 5.208vw" }}>
                <Footer />
            </div>
        </div>
    );
};

export default PrivacyNotice;